import { FC, MouseEvent } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { SEARCH_SPECIAL_OFFERS_SUGGESTIONS_COUNT } from '../../../constants';
import { ProductSearchItem, ProductSuggestionClickHandler, ServiceSearchItem } from '../../../model';
import { SEARCH_TEST_ID } from '../../../test/test-ids';
import { getFullUrl } from '../../../utils/paths';
import { ConnectedProductCardSmall } from '../../ConnectedProductCardSmall/ConnectedProductCardSmall';
import { ServiceCard } from '../../ServiceCard/ServiceCard';
import { SectionHeading, SuggestionsCardsWrapper } from '../SearchSuggestions.styles';

type Props = {
    title?: string;
    products: ProductSearchItem[];
    services: ServiceSearchItem[];
    onProductClick?: ProductSuggestionClickHandler;
    onServiceClick?: (product: ServiceSearchItem, event: MouseEvent) => void;
};

const SEARCH_SUGGESTIONS_SPECIAL_OFFERS = 'search-suggestions-special-offers';

export const SpecialOffersSuggestions: FC<Props> = ({ title, products, services, onProductClick, onServiceClick }) => {
    const { t } = useTranslations();

    const specialOffersProducts = products.slice(0, SEARCH_SPECIAL_OFFERS_SUGGESTIONS_COUNT);
    const specialOffersServices = services.slice(
        0,
        Math.max(SEARCH_SPECIAL_OFFERS_SUGGESTIONS_COUNT - specialOffersProducts.length, 0),
    );

    return (
        <section
            data-test={SEARCH_TEST_ID.SUGGESTIONS_SPECIAL_OFFERS}
            aria-labelledby={SEARCH_SUGGESTIONS_SPECIAL_OFFERS}
        >
            <SectionHeading tag="h2" variant="title-100" id={SEARCH_SUGGESTIONS_SPECIAL_OFFERS}>
                {title || t['search.suggestions.special_offers.title']}
            </SectionHeading>
            <SuggestionsCardsWrapper>
                {specialOffersProducts.slice(0, SEARCH_SPECIAL_OFFERS_SUGGESTIONS_COUNT).map((product) => (
                    <ConnectedProductCardSmall
                        key={product.id}
                        product={product}
                        onClick={(event) => onProductClick?.(product, event)}
                    />
                ))}
                {specialOffersServices.map((service) => (
                    <ServiceCard
                        key={service.id}
                        variant="minimal"
                        title={service.title}
                        icon={service.icon}
                        description={service.shortDescription}
                        url={getFullUrl(service.url)}
                        onClick={(event) => onServiceClick?.(service, event)}
                    />
                ))}
            </SuggestionsCardsWrapper>
        </section>
    );
};
